module.exports = __webpack_public_path__ + "media/5_BL.63b8a833.mp3";